"use strict";

var _regeneratorRuntime = require("/home/runner/work/websites/websites/finnoconsult.at/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/home/runner/work/websites/websites/finnoconsult.at/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recoilPersist = void 0;
/**
 * Recoil module to persist state to storage
 *
 * @param config Optional configuration object
 * @param config.key Used as key in local storage, defaults to `recoil-persist`
 * @param config.storage Local storage to use, defaults to `localStorage`
 */

var recoilPersist = function recoilPersist() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (typeof window === 'undefined') {
    return {
      persistAtom: function persistAtom() {}
    };
  }

  var _config$key = config.key,
      key = _config$key === void 0 ? 'recoil-persist' : _config$key,
      _config$storage = config.storage,
      storage = _config$storage === void 0 ? localStorage : _config$storage;

  var persistAtom = function persistAtom(_ref) {
    var onSet = _ref.onSet,
        node = _ref.node,
        trigger = _ref.trigger,
        setSelf = _ref.setSelf;

    if (trigger === 'get') {
      var state = getState();

      if (typeof state.then === 'function') {
        state.then(function (s) {
          if (s.hasOwnProperty(node.key)) {
            setSelf(s[node.key]);
          }
        });
      }

      if (state.hasOwnProperty(node.key)) {
        setSelf(state[node.key]);
      }
    }

    onSet( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(newValue, _, isReset) {
        var state;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = getState();

                if (typeof state.then === 'function') {
                  state.then(function (s) {
                    return updateState(newValue, s, node.key, isReset);
                  });
                } else {
                  updateState(newValue, state, node.key, isReset);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
  };

  var updateState = function updateState(newValue, state, key, isReset) {
    if (isReset) {
      delete state[key];
    } else {
      state[key] = newValue;
    }

    setState(state);
  };

  var getState = function getState() {
    var toParse = storage.getItem(key);

    if (toParse === null || toParse === undefined) {
      return {};
    }

    if (typeof toParse === 'string') {
      return parseState(toParse);
    }

    if (typeof toParse.then === 'function') {
      return toParse.then(parseState);
    }

    return {};
  };

  var parseState = function parseState(state) {
    if (state === undefined) {
      return {};
    }

    try {
      return JSON.parse(state);
    } catch (e) {
      console.error(e);
      return {};
    }
  };

  var setState = function setState(state) {
    try {
      if (typeof storage.mergeItem === 'function') {
        storage.mergeItem(key, JSON.stringify(state));
      } else {
        storage.setItem(key, JSON.stringify(state));
      }
    } catch (e) {
      console.error(e);
    }
  };

  return {
    persistAtom: persistAtom
  };
};

exports.recoilPersist = recoilPersist;